import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import iconHelp from 'src/assets/images/icon_help.svg';
import ExcessiveTradingPolicyNote from 'src/components/Shared/ExcessiveTradingPolicyNote/ExcessiveTradingPolicyNote';
import FullPageLoader from 'src/components/Shared/FullPageLoader/FullPageLoader';
import StepsPageBackground from 'src/components/Shared/StepsPageBackground/StepsPageBackground';
import {
  getHasFailed,
  getIsLoading,
} from 'src/redux/modules/applicationData/applicationData.selectors';
import {
  getAutoRedemption,
  getAutoSellSubmitResult,
} from 'src/redux/modules/executeRedemption/selectors';
import { getBalanceAsOfDate } from 'src/redux/modules/funds/UserFunds/userFunds.selectors';
import { openModal } from 'src/redux/modules/modals/actions';
import { appendBasePath } from 'src/utils/nav.utils';
import { BALANCES_AS_OF_MODAL } from 'src/redux/modules/modals/modals.module';
import { getProductTypes } from 'src/redux/modules/productTypes/productType.selectors';
import { ProductTypeEntity } from 'src/redux/modules/productTypes/types';
import { getIsZeroDollarBalanceFund } from 'src/redux/modules/sellTransaction/sellTransaction.selectors';
import {
  getDateOfBirth,
  getIsAddressAvailable,
  getIsNotForeignAddress,
  didPersonalInformationFail,
} from 'src/redux/modules/user/PersonalInformation/personalInformation.selectors';
import {
  ADDRESS_INCOMPLETE,
  APP_FAILURE,
  COLLEGE_SELL_REDIRECT,
  DOB_FAILURE,
  executingSellMessages,
  FOREIGN_ADDRESS,
  loadingBuySellAppMessages,
  TIMEOUT,
  ZERO_BALANCE_FUND,
  RECURRING_PURCHASE_APP_FAILURE,
} from 'src/settings/settings';
import { AutoSellSteps } from '../AutoSellSteps';
import If from '../../Shared/If/If';
import {
  isEmbeddedInIFrame,
  isSalesforceRep,
  isCustomerWebViewEnabled,
} from 'src/redux/modules/authentication/authentication.module.selectors';

export interface AutoSellLandingProps {
  isCorporateAccountType?: boolean;
}
export const AutoSellLanding: React.FC<AutoSellLandingProps> = ({
  isCorporateAccountType,
}) => {
  const isIFrame: boolean = useSelector(isEmbeddedInIFrame);
  const customerWebViewEnabled: boolean = useSelector(isCustomerWebViewEnabled);
  const isSalesforceRepEnabled: boolean = useSelector(isSalesforceRep);
  const history = useHistory();
  const dispatch = useDispatch();
  const isApplicationLoading = useSelector(getIsLoading);
  const hasApplicationFailed = useSelector(getHasFailed);
  const { autoSellLoading } = useSelector(getAutoRedemption);
  const balanceAsOfDate = useSelector(getBalanceAsOfDate);
  const dateOfBirth = useSelector(getDateOfBirth);
  const personalInfoFailed = useSelector(didPersonalInformationFail);
  const isAddressAvailable = useSelector(getIsAddressAvailable);
  const isNotForeignAddress = useSelector(getIsNotForeignAddress);
  const isZeroDollarBalanceFund = useSelector(getIsZeroDollarBalanceFund);
  const productTypes: ProductTypeEntity = useSelector(getProductTypes);
  const { autoSellLoaded, autoSellFailed, autoSomeFailed, autoAllFailed } =
    useSelector(getAutoSellSubmitResult);
  const hasMutualFund = productTypes?.hasMutualFund;
  const isLoaderVisible = isApplicationLoading || autoSellLoading;
  const message = isApplicationLoading
    ? loadingBuySellAppMessages
    : autoSellLoading
    ? executingSellMessages
    : '';
  const goToConfirmPage =
    autoSellLoaded && !autoSellFailed && !autoSomeFailed && !autoAllFailed;
  useEffect(() => {
    if (goToConfirmPage) {
      //todo move this to a saga
      history.push(appendBasePath('/automatic/sell/confirm'));
    }
  }, [history, goToConfirmPage]);

  const getError = () => {
    if (!personalInfoFailed && !dateOfBirth && !isCorporateAccountType) {
      return {
        type: DOB_FAILURE,
        hasError: true,
      };
    }
    if (!personalInfoFailed && !isNotForeignAddress) {
      return {
        type: FOREIGN_ADDRESS,
        hasError: true,
      };
    }
    if (hasApplicationFailed) {
      return {
        type: APP_FAILURE,
        hasError: true,
      };
    }
    if (autoSellFailed) {
      return {
        type: TIMEOUT,
        hasError: true,
      };
    }
    if (!isAddressAvailable) {
      return {
        type: ADDRESS_INCOMPLETE,
        hasError: true,
      };
    }
    if (isZeroDollarBalanceFund) {
      return {
        type: ZERO_BALANCE_FUND,
        hasError: true,
      };
    }
    if (!hasMutualFund) {
      return {
        type: COLLEGE_SELL_REDIRECT,
        hasError: true,
      };
    }
    if (autoSomeFailed || autoAllFailed) {
      return {
        type: RECURRING_PURCHASE_APP_FAILURE,
        hasError: true,
      };
    }
    return {
      type: '',
      hasError: false,
    };
  };
  return (
    <div id="sell-page-container">
      <FullPageLoader
        errorType={getError().type}
        hasError={getError().hasError}
        isVisible={isLoaderVisible}
        messages={message}
      />

      <If
        test={
          !(isIFrame || (!customerWebViewEnabled && isSalesforceRepEnabled))
        }
      >
        <StepsPageBackground />
      </If>
      <div className="container">
        <AutoSellSteps />

        <a
          className="sell-landing-balance-tooltip"
          onClick={() => dispatch(openModal(BALANCES_AS_OF_MODAL, {}))}
        >
          * Balances as of {balanceAsOfDate}
          <img
            alt="help"
            className="sell-landing-balance-tooltip-icon"
            id="balance-tooltip-icon"
            src={iconHelp}
          />
        </a>
        <hr />
        <ExcessiveTradingPolicyNote />
        <p style={{ margin: '10px 0' }}>2909931</p>
      </div>
    </div>
  );
};

export default AutoSellLanding;
